import axios from "axios";
import { MDBBtn } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";

import API_BASE_URL from "../utilities/apiConfig";
import { toast } from "react-toastify";
import FeesDetailsTableMonthly from "../components/apiComponents/FeesDetailsTableMonthly";
import VoucherDataTableMonthly from "../components/apiComponents/VoucherDataTableMonthly";
import axiosInstance from "../utilities/apiConfig";

const FeesAndVoucherDetails = () => {
  const detailsTableInitialParams = {
    detailsTypes: "",
    selectedMonth: "",
    selectedYear: "",
  };

  const [searchParams, setSearchParams] = useState(detailsTableInitialParams);
  const [feesTableData, setFeesTableData] = useState("");
  const [voucherTableData, setVoucherTableData] = useState("");
  const [isFeesData, setIsFeesData] = useState(false);
  const [isVoucherData, setIsVoucherData] = useState(false);

  const months = [
    { value: 1, name: "January" },
    { value: 2, name: "February" },
    { value: 3, name: "March" },
    { value: 4, name: "April" },
    { value: 5, name: "May" },
    { value: 6, name: "June" },
    { value: 7, name: "July" },
    { value: 8, name: "August" },
    { value: 9, name: "September" },
    { value: 10, name: "October" },
    { value: 11, name: "November" },
    { value: 12, name: "December" },
  ];

  // Determine the current year
  const currentYear = new Date().getFullYear();

  // Generate an array of years from 2023 to the current year
  const years = [];
  for (let year = 2024; year <= currentYear; year++) {
    years.push(year);
  }

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setSearchParams({
      ...searchParams,
      [name]: value,
    });
  };

  const handleFeesAndVoucherDetailsGet = async () => {
    try {
      setIsFeesData(false);
      setIsVoucherData(false);

      const response = await axiosInstance.get(
        `/Dashboard/get_fees_voucher_and_fees_details_month_wise?DetailsTypeId=${searchParams.detailsTypes}&MonthId=${searchParams.selectedMonth}&YearId=${searchParams.selectedYear}`
      );
      console.log(response.data);
      if (response.data.response.statusCode === 200) {
        if (response?.data?.advocateVoucherDetails) {
          setVoucherTableData(response?.data?.advocateVoucherDetails);
          setIsVoucherData(true);
        }
        if (response?.data?.advocateFeesDetails) {
          setFeesTableData(response?.data?.advocateFeesDetails);
          setIsFeesData(true);
        }
        toast.success(response.data.response.status);
      } else {
        toast.error(response.data.response.status);
      }
    } catch (error) {
      console.log("fees or voucher details api error", error);
    }
  };

  const feesTableColumns = [
    {
      field: "advocateBarId",
      headerName: "Registration No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'membershipTypeId', headerName: 'Membership Type ID', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    {
      field: "memberType",
      headerName: "Member Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "feesAmount",
      headerName: "Fees Amount",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "entryDate",
      headerName: "Entry Date",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "bookNo",
      headerName: "Book No",
      minWidth: 100,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "srNo",
      headerName: "Serial No",
      minWidth: 100,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'userId', headerName: 'User ID', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'barAssociationCode', headerName: 'Bar Association Code', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    {
      field: "userName",
      headerName: "Name",
      minWidth: 200,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
  ];

  const voucherTableColumns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherType",
      headerName: "Voucher Type",
      type: "text",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherBookNo",
      headerName: "Book No",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherSrNo",
      headerName: "Sr No",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherAmount",
      headerName: "Amount",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Purchaser Name",
      minWidth: 130,
      flex: 1.5,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "purchaserType",
      headerName: "Purchaser Type",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "uttrakhandBarId",
      headerName: "Purchaser ID",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherPurchaseDate",
      headerName: "Purchase Date",
      minWidth: 160,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "userName",
      headerName: "Name",
      minWidth: 200,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
  ];

  useEffect(() => {
    console.log(searchParams);
  }, [searchParams]);

  return (
    <>
      <div className="row justify-content-center mb-4 mt-5">
        <div className="col-xxl-8">
          <div className="row">
            <div className="col">
              <label htmlFor="detailsTypes">Fees & Voucher Details </label>
              <select
                className="form-select"
                name="detailsTypes"
                onChange={(e) => {
                  handleSelectChange(e);
                }}
              >
                <option value="">Select</option>
                <option value="1">Fees Details</option>
                <option value="2">Vouchers Details</option>
              </select>
            </div>
            <div className="col">
              <label htmlFor="selectedMonth">Month</label>
              <select
                id="selectedMonth"
                name="selectedMonth"
                onChange={(e) => {
                  handleSelectChange(e);
                }}
                className="form-select"
              >
                <option value="">Select</option>
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label htmlFor="selectedYear">Select Year</label>
              <select
                id="selectedYear"
                name="selectedYear"
                onChange={(e) => {
                  handleSelectChange(e);
                }}
                className="form-select"
              >
                <option value="">Select</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div className="col mt-auto">
              <MDBBtn
                onClick={() => {
                  handleFeesAndVoucherDetailsGet();
                }}
              >
                Get Data
              </MDBBtn>
            </div>
          </div>
        </div>
      </div>

      {isFeesData && (
        <FeesDetailsTableMonthly
          tableName={"Fees Details Table"}
          feesDetailsData={feesTableData}
          height={700}
          TableColumns={feesTableColumns}
        />
      )}
      {isVoucherData && (
        <VoucherDataTableMonthly
          tableName={"Voucher Details Table"}
          TableData={voucherTableData}
          height={700}
          TableColumns={voucherTableColumns}
        />
      )}
    </>
  );
};

export default FeesAndVoucherDetails;
